"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _disrupt = _interopRequireDefault(require("@ux/disrupt"));

var _dialog = _interopRequireDefault(require("@ux/dialog"));

var _legacy = require("./legacy");

const _excluded = ["children", "className", "focusLock", "onClose", "onEventBehind", "portalElem", "stretch", "strategy", "show"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

const UX_MODAL_CLASSNAME = 'ux-modal';

function Modal(props) {
  const {
    children,
    className,
    focusLock = true,
    onClose,
    onEventBehind,
    portalElem,
    stretch,
    strategy,
    show
  } = props,
        dialogProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  if (typeof show !== 'undefined' && !show) return null;
  if (!portalElem && (typeof document === 'undefined' || !document.body)) return null;
  return /*#__PURE__*/_react.default.createElement(_disrupt.default, {
    portalElem: portalElem || document.body,
    strategy: strategy || 'fixed',
    onClose: onClose,
    focusLock: focusLock,
    onEventBehind: onEventBehind,
    stretch: stretch
  }, /*#__PURE__*/_react.default.createElement(_dialog.default, (0, _extends2.default)({
    "aria-modal": true,
    role: "dialog",
    className: (0, _classnames.default)(UX_MODAL_CLASSNAME, className),
    onClose: onClose
  }, (0, _legacy.transform)(dialogProps)), children));
}

Modal.propTypes = _objectSpread(_objectSpread({}, _disrupt.default.propTypes), _dialog.default.propTypes);
var _default = Modal;
exports.default = _default;